import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import SpinnerComp from '../../components/util/SpinnerComp'
import {
  getMyAccount,
  updateMyAccount,
  updateMyPassword,
} from '../../features/profile/profileSlice'
import { setToken } from '../../features/auth/authSlice'

const MyPage = () => {
  // Redux State
  const { token } = useSelector((state) => state.auth)
  const { profile, profileLoading } = useSelector((state) => state.profile)

  const dispatch = useDispatch()

  useEffect(() => {
    if (token) {
      dispatch(getMyAccount(token))
        .unwrap()
        .then(({ res, newToken }) => {
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        })
        .catch((error) => {})
    }
    // eslint-disable-next-line
  }, [dispatch])

  //   編集 My Page
  const [editTarget, setEditTarget] = useState(null)
  const [editPasswordTarget, setEditPasswordTarget] = useState(null)
  //   edit user data
  const [userNameEdit, setUserNameEdit] = useState('')
  const [userDepartmentEdit, setUserDepartementEdit] = useState('')
  //   edit password
  const [userPasswordEdit, setUserPasswordEdit] = useState('')
  const [userPasswordConfirmEdit, setUserPasswordConfirmEdit] = useState('')
  const [showPasswordEdit, setShowPasswordEdit] = useState('password')
  const [showPasswordConfirmEdit, setShowPasswordConfirmEdit] =
    useState('password')

  useEffect(() => {
    if (editTarget !== null) {
      setUserNameEdit(editTarget.user_name)
      setUserDepartementEdit(editTarget.department)
    }
  }, [editTarget])

  const editUserhandler = () => {
    if (userNameEdit === '' || userDepartmentEdit === '') {
      toast.error('ユーザー名と部署を空欄にしてはいけません')
    }

    if (
      userNameEdit.trim().length < 4 ||
      userDepartmentEdit.trim().length < 4
    ) {
      toast.error('ユーザー名と部署は少なくとも4文字以上である必要があります')
    }

    if (
      userNameEdit !== '' &&
      userNameEdit.length >= 4 &&
      userDepartmentEdit !== '' &&
      userDepartmentEdit.length >= 4
    ) {
      const data = {
        user_name: userNameEdit,
        department: userDepartmentEdit,
      }
      //   console.log(data)
      dispatch(updateMyAccount({ data, token }))
        .unwrap()
        .then(({ res, newToken }) => {
          dispatch(getMyAccount(token))
          setEditTarget(null)
          toast.success('プロフィールが更新されました')
          if (res.data && res.data.result === 'success' && newToken) {
            dispatch(setToken(newToken))
          }
        })
        .catch((error) => {})
    }
  }

  //   cancel edit
  const cancelEditHadnler = () => {
    setEditTarget(null)
    setUserNameEdit('')
    setUserDepartementEdit('')
  }

  //   Show Password handler
  const showPasswordEditHandler = () => {
    if (showPasswordEdit === 'password') setShowPasswordEdit('text')
    if (showPasswordEdit === 'text') setShowPasswordEdit('password')
  }
  const showPasswordConfirmEditHandler = () => {
    if (showPasswordConfirmEdit === 'password')
      setShowPasswordConfirmEdit('text')
    if (showPasswordConfirmEdit === 'text')
      setShowPasswordConfirmEdit('password')
  }

  //   編集 Password Handler
  const setEditPasswordHandler = (value) => {
    setEditPasswordTarget(value)
    if (showPasswordEdit === 'text') setShowPasswordEdit('password')
  }

  //   cancel edit password
  const cancelPasswordEditHadnler = () => {
    setEditPasswordTarget(null)
    setUserPasswordEdit('')
    setUserPasswordConfirmEdit('')
    setShowPasswordEdit('password')
    setShowPasswordConfirmEdit('password')
  }

  //   password edit submit handler
  const passwordEditSubmitHandler = () => {
    if (userPasswordEdit !== userPasswordConfirmEdit) {
      toast.error('パスワードと確認用パスワードが一致していません')
      return
    }

    const passwordRegex = /^.{12,}$/
    if (!passwordRegex.test(userPasswordEdit)) {
      toast.error('パスワードは12文字以上でご設定をお願いいたします。')
      return
    }

    const data = {
      password: userPasswordEdit,
      confirm_password: userPasswordConfirmEdit,
    }
    // console.log(data)
    dispatch(updateMyPassword({ data, token }))
      .unwrap()
      .then(({ res, newToken }) => {
        dispatch(getMyAccount(token))
        setEditPasswordTarget(null)
        toast.success('パスワードが更新されました')
        setUserPasswordEdit('')
        setUserPasswordConfirmEdit('')
        if (res.data && res.data.result === 'success' && newToken) {
          dispatch(setToken(newToken))
        }
      })
      .catch((error) => {})
  }

  return (
    <div className="w-full mb-8 px-4">
      <h1 className="text-center my-4 text-2xl leading-snug uppercase">
        マイページ
      </h1>
      {profileLoading ? (
        <SpinnerComp />
      ) : (
        <>
          {profile && profile.result === 'success' && (
            <div>
              {/* Change Username and Affiliation */}
              <div className="w-full flex flex-col gap-4 mt-6">
                <h1>ユーザー名、所属の編集</h1>

                <div className="w-full w-12/12 flex flex-col lg:flex-row gap-2 p-2 rounded-[12px] border border-gray-800">
                  {/* Email */}
                  <p className="w-full outline-none p-2 bg-gray-300 rounded-[8px] overflow-x-auto">
                    {profile.value.user_id}
                  </p>
                  {/* End Email */}

                  {/* UserName */}
                  <input
                    type="text"
                    onChange={(e) =>
                      editTarget && setUserNameEdit(e.target.value)
                    }
                    value={
                      editTarget && editTarget?.id === profile.value.id
                        ? userNameEdit
                        : profile.value.user_name
                    }
                    disabled={
                      editTarget?.id !== profile.value.id ? 'disabled' : ''
                    }
                    className={
                      `w-full outline-none p-2 rounded-[8px] ` +
                      `${
                        editTarget?.id !== profile.value.id
                          ? 'bg-gray-300'
                          : 'bg-white border border-gray-800'
                      }`
                    }
                  />
                  {/* End UserName */}

                  {/* Department */}
                  <input
                    type="text"
                    onChange={(e) =>
                      editTarget && setUserDepartementEdit(e.target.value)
                    }
                    value={
                      editTarget && editTarget?.id === profile.value.id
                        ? userDepartmentEdit
                        : profile.value.department
                    }
                    disabled={
                      editTarget?.id !== profile.value.id ? 'disabled' : ''
                    }
                    className={
                      `w-full outline-none p-2 rounded-[8px] ` +
                      `${
                        editTarget?.id !== profile.value.id
                          ? 'bg-gray-300'
                          : 'bg-white border border-gray-800'
                      }`
                    }
                  />
                  {/* End Department */}

                  <p className="w-full outline-none p-2 bg-gray-300 rounded-[8px] overflow-x-auto">
                    {profile.value.auth === 0 && 'オブザーバー'}
                    {profile.value.auth === 1 && 'スタッフ'}
                    {profile.value.auth === 2 && '管理者'}
                    {profile.value.auth === 3 && 'Admin Super'}
                  </p>

                  <div className="w-full flex gap-2 justify-end">
                    {editTarget && editTarget.id === profile.value.id ? (
                      <>
                        <button
                          onClick={editUserhandler}
                          className="w-max px-8 py-[2px] rounded-[8px] bg-blue-800 text-white"
                        >
                          確認
                        </button>
                        <button
                          onClick={cancelEditHadnler}
                          className="w-max px-8 py-[2px] rounded-[8px] bg-gray-500 text-white"
                        >
                          キャンセル
                        </button>
                      </>
                    ) : (
                      <button
                        onClick={() => setEditTarget(profile.value)}
                        className="w-max px-8 py-[2px] rounded-[8px] bg-blue-800 text-white"
                      >
                        編集
                      </button>
                    )}
                  </div>
                </div>
              </div>
              {/* End Change Username and Affiliation */}

              {/* Change Password */}
              <div className="w-full flex flex-col gap-4 mt-6">
                <h1>パスワードの編集</h1>
                <div className=" mb-4 p-2 rounded-[12px] border border-gray-800">
                  <div className="w-full w-12/12 flex flex-col md:justify-between items-center md:flex-row gap-2 my-2">
                    <div className="w-full flex flex-col">
                      <p>新しいパスワード</p>
                      <div className="w-full flex justify-start items-center gap-2">
                        <input
                          type={showPasswordEdit}
                          disabled={!editPasswordTarget}
                          value={userPasswordEdit}
                          onChange={(e) =>
                            editPasswordTarget &&
                            setUserPasswordEdit(e.target.value)
                          }
                          className={
                            `w-full outline-none p-2 rounded-[8px] ` +
                            `${
                              editPasswordTarget
                                ? 'bg-white border border-gray-800'
                                : 'bg-gray-300'
                            }`
                          }
                        />
                        <button
                          onClick={showPasswordEditHandler}
                          className="text-xl"
                        >
                          {showPasswordEdit === 'password' && <FaEye />}
                          {showPasswordEdit === 'text' && <FaEyeSlash />}
                        </button>
                      </div>
                    </div>

                    <div className="w-full flex flex-col">
                      <p>新しいパスワードの確認</p>
                      <div className="w-full flex justify-start items-center gap-2">
                        <input
                          type={showPasswordConfirmEdit}
                          disabled={!editPasswordTarget}
                          value={userPasswordConfirmEdit}
                          onChange={(e) =>
                            editPasswordTarget &&
                            setUserPasswordConfirmEdit(e.target.value)
                          }
                          className={
                            `w-full outline-none p-2 rounded-[8px] ` +
                            `${
                              editPasswordTarget
                                ? 'bg-white border border-gray-800'
                                : 'bg-gray-300'
                            }`
                          }
                        />
                        <button
                          onClick={showPasswordConfirmEditHandler}
                          className="text-xl"
                        >
                          {showPasswordConfirmEdit === 'password' && <FaEye />}
                          {showPasswordConfirmEdit === 'text' && <FaEyeSlash />}
                        </button>
                      </div>
                    </div>

                    <div className="w-full flex gap-2 justify-center md:justify-end">
                      {editPasswordTarget ? (
                        <>
                          <button
                            onClick={passwordEditSubmitHandler}
                            className="w-max px-8 py-[2px] rounded-[8px] bg-blue-800 text-white"
                          >
                            確認
                          </button>
                          <button
                            onClick={cancelPasswordEditHadnler}
                            className="w-max px-8 py-[2px] rounded-[8px] bg-gray-500 text-white"
                          >
                            キャンセル
                          </button>
                        </>
                      ) : (
                        <button
                          onClick={() => setEditPasswordHandler(profile.value)}
                          className="w-max px-8 py-[2px] rounded-[8px] bg-blue-800 text-white"
                        >
                          編集
                        </button>
                      )}
                    </div>
                  </div>

                  {editPasswordTarget && (
                    <p className="font-semibold text-black">
                      パスワードは12文字以上でご設定をお願いいたします。
                    </p>
                  )}
                </div>
              </div>
              {/* End Change Password */}
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default MyPage
